import React from 'react'
import { Career } from '../components'

const CareerPage = () => {
  return (
    <div className='flex justify-center items-center'>
        <Career />
    </div>
  )
}

export default CareerPage